/* @flow */
import * as React from 'react';

import Text from 'components/Text.jsx';

type Props = {
  number: number,
  isPercentage?: boolean,
};

function ErrorCell({ number, isPercentage }: Props) {
  if (isNaN(number)) {
    return <span />;
  }
  const content = isPercentage ? `${number * 100}%` : number;
  const hasErrors = number > 0;
  return <Text color={hasErrors ? 'lava' : 'inherit'}>{content}</Text>;
}

export function getErrorCellGenerator(fieldName: string) {
  return (data: Object) => {
    return <ErrorCell number={data[fieldName]} />;
  };
}

export function getErrorPercentageCellGenerator(fieldName: string) {
  return (data: Object) => {
    return <ErrorCell number={data[fieldName]} isPercentage />;
  };
}
